import VueRouter from "vue-router";
import Home from "./modules/Home";
import Login from "./modules/Login";
import NotFound from "./modules/404";

// 用户管理
import User from "./modules/user/Index";
import UserList from "./modules/user/List";
import UserAccountList from "./modules/user/AccountList";
import UserDetail from "./modules/user/Detail";

// 产品管理(old)
import Product from "./modules/product/Index";
// import CompanyOldList from "./modules/product/CompanyList";
// import ProductList from "./modules/product/ProductList";

// 保险公司库
import CompanyList from './modules/company/List';

// 产品管理
import AddProduct from "./modules/product_management/AddProduct";
import PendingProduct from "./modules/product_management/PendingList";
import PublishedProduct from "./modules/product_management/PublishedList";
import EditProduct from "./modules/product_management/EditProduct";

//产品库
import ProductLibrary from './modules/product_library/Index'
import ProductLibraryAdd from './modules/product_library/AddProductLibrary'
import ProductLibraryEdit from './modules/product_library/EditProductLibrary'
import ProductLibraryList from './modules/product_library/ProductLibraryList'

// 理先生
import LiOnline from "./modules/li-online/Index";

// 管理员
import Admin from "./modules/admin/Index";
import AdminList from "./modules/admin/List";

// 代理人
import Agent from "./modules/agent/Index";
import AgentList from "./modules/agent/List";
import AgentDetail from "./modules/agent/Detail";
import AgentVerifyList from "./modules/agent/VerifyList";
import VerifyLogList from "./modules/agent/VerifyLogList";
import AgentClientList from "./modules/agent/CilentList";
import AgentVCardWarn from "./modules/agent/VCardRiskWarn";
import AgentCustom from './modules/agent/Custom';

// CMS
// import Cms from "./modules/cms/Index";
// import ArticleList from "./modules/cms/AtricleList";
// import ArticleAdd from "./modules/cms/ArticleAdd";

// 统计
import Statistics from "./modules/statistics/Index";
import StatisticsSummary from "./modules/statistics/Summary";
import Article from "./modules/statistics/Article";
import Transactions from "./modules/statistics/Transactions";

//工具
import Tools from "./modules/tools/Index";
import WxMenuUpdate from "./modules/tools/WxMenuUpdate";
import DomainList from "./modules/tools/DomainList";
import WxMediaId from "./modules/tools/WxMediaId";
import ChatRoomList from "./modules/tools/ChatRoomList";
import QrCodeChannelList from "./modules/tools/QrCodeChannelList";
import GenerateImg from "./modules/tools/GenerateImg";
import ChangeDomain from "./modules/tools/ChangeDomain";
import MessageBroadcast from "./modules/tools/MessageBroadcast";
import Notice from './modules/message/Notice'
import UserTagManage from './modules/tools/UserTagManage'
import UserTagItem from './modules/tools/UserTagItem'

// 会员
// import Vip from "./modules/vip/Index";
import UserLevelRights from "./modules/vip/UserLevelRights";
import MemberProduct from "./modules/vip/MemberProduct";
import AssignMembers from "./modules/vip/AssignMembers";

// 活动
import ActivityList from "./modules/activity/ActivityList"

// shop
import Shop from './modules/shop/Index'
import ShopOrder from './modules/shop/OrderList'
import ShopChannelList from './modules/shop/ChannelList'
import ShopChannelItemList from './modules/shop/ChannelItemList'
import ShopChannelSaleList from './modules/shop/ChannelSaleList'
import ShopChannelStatistics from './modules/shop/ChannelStatistics'

// Partner
import Partner from './modules/partner/Abs'
import PartnerList from './modules/partner/List'
import PartnerOrder from './modules/partner/Order'
/*import AdviserList from './modules/partner/AdviserList'*/
import IdentityList from './modules/partner/IdentityList'

import Param from './modules/ui/Param'
import ProductUpdate from "@/modules/tools/ProductUpdate";

import PolicyCommission from '@/modules/partner/PolicyCommission'

// ERP
import ERP from './modules/erp/Index'
import ERPTodo from './modules/erp/Todo'
import ERPEdit from './modules/erp/Edit'

// Order
// import Order from './modules/order/Index'
import OrderList from './modules/order/List'
import Insert from './modules/order/Insert'
import PolicyList from "./modules/policy/List";

// Wallet
// import Wallet from './modules/wallet/Index'
import WalletList from './modules/wallet/List'
import Withdraw from './modules/wallet/Withdraw'

// 客服
import CustomService from './modules/custom-service/Index'
import TeamList from './modules/custom-service/TeamList'
import CustomerList from './modules/custom-service/CustomerList'
import TeamMember from './modules/custom-service/TeamMember'
import PendingEvent from './modules/custom-service/PendingEvent'

//供应链管理
//import SupplyChainManage from './modules/supply_chain/Index'

//saas供应链管理
import SaasSupplyChainManage from './modules/saas_supply/Index'
import SaasProductList from './modules/saas_supply/ProductList'

//saas平台
import Saas from './modules/saas/Index'
import SaasUser from './modules/saas/UserList'
import SaasUserDetailAndRemark from './modules/saas/UserDetailAndRemark'
import SaasCertification from './modules/saas/Certification'
import SaasOrder from './modules/saas/OrderList'
//import SaasRewardList from './modules/saas/RewardList'
import SaasRewardSetting from './modules/saas/RewardSetting'
import SaasWithdrawRecord from './modules/saas/WithdrawRecord'
import SaasActivityWithdrawApply from './modules/saas/ActivityWithdrawApply'
import SaasChannel from './modules/saas/Channel'
import SaasTools from './modules/saas/Tools'
import SettlementRate from './modules/rate/SettlementRate'
import TaxRate from './modules/rate/TaxRate'

const routes = [
  { path: "/", component: Home, meta: { title: "欢迎使用" } },
  {
    path: "/login",
    component: Login,
    meta: { title: "登陆", nonav1: true, nonav2: true }
  },
  { path: "/404", component: NotFound, meta: { title: "404页面未找到" } },
  { path: "*", redirect: "/404" },
    {
        path: '/partner',
        component: Partner,
        name: '合伙人',
        children: [
            { path: "/", redirect: "list" },
            {
                path: "list",
                name: "合伙人列表",
                component: PartnerList,
                granted: ac => ac.check("/agent/agent_tree_list")
            },
            {
                path: 'order',
                name: '预约订单列表',
                component: PartnerOrder,
                granted: ac => ac.check("/partner/mk_order_list")
            },
            // {
            //   path: 'adviser',
            //   name: '预约顾问列表',
            //   component: AdviserList,
            //   granted: ac => ac.check("/partner/adviser_list")
            // },
            {
                path: 'identity',
                name: '实名认证',
                component: IdentityList,
                granted: ac => ac.check("/uc/identity_list")
            },
            {
                path: 'policy_commission',
                name: '保单佣金规则',
                component: PolicyCommission,
                granted: ac => ac.check("/tools/partner_policy_commission")
            },
            {
                path: 'policy',
                name: '保险订单列表',
                component: OrderList,
                granted: ac => ac.check("/policy/order_list")
            },
            {
                path: 'insert',
                name: '保单手动录入',
                component: Insert,
                granted: ac => ac.check("/policy/defined_get")
            },
            {
                path: 'wallet_list',
                name: '钱包账户列表',
                component: WalletList,
                granted: ac => ac.check("/wallet/business_list")
            },
            {
                path: 'withdraw',
                name: '提现管理',
                component: Withdraw,
                granted: ac => ac.check("/wallet/withdraw_list")
            },
        ]
    },
  // {
  //   path: "/product",
  //   component: Product,
  //   name: "产品管理(old)",
  //   children: [
  //     { path: "/", redirect: "company_list" },
  //     {
  //       path: "company_list",
  //       name: "公司列表",
  //       component: CompanyOldList,
  //       meta: { title: "保险公司列表", requiresAuth: true },
  //       granted: ac => {
  //         return ac.check("/front/product_get_company_list");
  //       }
  //     },
  //     {
  //       path: "product_list",
  //       name: "产品列表",
  //       component: ProductList,
  //       meta: { title: "保险产品列表", requiresAuth: true },
  //       granted: ac => {
  //         return ac.check("/front/product_get_list");
  //       }
  //     }
  //   ]
  // },
  {
    path: "/product_management",
    component: Product,
    name: "产品管理",
    children: [
      { path: "/", redirect: "pending_list" },
      {
        path: "list",
        name: "已发布列表",
        component: PublishedProduct,
        meta: { title: "已发布的保险产品", requiresAuth: true },
        granted: ac => {
          return (
            ac.check("/product/ui_get_tmpl") &&
            ac.check("/product/product_get_list")
          );
        }
      },
      {
        path: "pending_list",
        name: "待发布列表",
        component: PendingProduct,
        meta: { title: "待发布的保险产品", requiresAuth: true },
        granted: ac => {
          return (
            ac.check("/product/ui_get_tmpl") &&
            ac.check("/product/product_get_pending_list")
          );
        }
      },
      {
        path: "edit/:type/:id",
        component: EditProduct,
        meta: { requiresAuth: true },
        granted: ac => {
          return (
            ac.check("/product/ui_get_tmpl") &&
            ac.check("/product/product_add_or_modify")
          );
        }
      },
      {
        path: "add_product",
        name: "添加产品",
        component: AddProduct,
        meta: { title: "添加保险产品", requiresAuth: true },
        granted: ac => {
          return (
            ac.check("/product/ui_get_tmpl") &&
            ac.check("/product/product_add_or_modify")
          );
        }
      },
      {
        path: "company_list",
        name: "保险公司列表",
        component: CompanyList,
        meta: { title: "保险公司列表", requiresAuth: true },
        granted: ac => {
          return ac.check("/company/company_list");
        }
      },
      {
        path: "policy_list",
        name: "保单列表",
        component: PolicyList,
        meta: { title: "保单列表列表", requiresAuth: true },
        granted: ac => {
          return ac.check("/policy/policy_get_list");
        }
      }
    ]
  },
    {
        path: "/product_library",
        component: ProductLibrary,
        name: "产品库",
        children: [
            { path: "/", redirect: "add" },
            {
                path: "add",
                name: "添加产品",
                component: ProductLibraryAdd,
                meta: { title: "添加产品", requiresAuth: true },
                granted: ac => {
                    return (
                        ac.check("/product_new/to_type") &&
                        ac.check("/product_new/save")
                    );
                }
            },
            {
                path: "list",
                name: "产品列表",
                component: ProductLibraryList,
                meta: { title: "产品列表", requiresAuth: true },
                granted: ac => {
                    return (
                        ac.check("/product_new/list")
                    );
                }
            },
            {
                path: "edit",
                component: ProductLibraryEdit,
                meta: { title: "产品编辑", requiresAuth: true },
                granted: ac => {
                    return (
                        ac.check("/product_new/list")
                    );
                }
            },
        ]
    },
  {
    path: "/li-online",
    granted: ac => {
      return ac.check("/chat/user_get_list");
    },
    component: LiOnline,
    name: "理先生在线",
    meta: { title: "理先生在线", requiresAuth: true }
  },
  
  // {
  //   path: "/cms",
  //   granted: ac => ac.check("/cms/article_get_list"),
  //   component: Cms,
  //   name: "内容管理",
  //   children: [
  //     { path: "/", redirect: "list" },
  //     {
  //       path: "list",
  //       name: "文章列表",
  //       component: ArticleList,
  //       granted: ac => ac.check("/cms/article_get_list")
  //     },
  //     {
  //       path: "add",
  //       name: "添加文章",
  //       component: ArticleAdd,
  //       granted: ac => ac.check("/cms/article_add")
  //     },
  //     {
  //       path: "add/:id",
  //       component: ArticleAdd,
  //       granted: ac => ac.check("/cms/article_add")
  //     }
  //   ]
  // },
  {
    path: "/statistics",
    component: Statistics,
    name: "统计",
    children: [
      { path: "/", redirect: "summary" },
      {
        path: "summary",
        component: StatisticsSummary,
        name: "代理人总览",
        meta: {
          title: "代理人统计总览",
          requiresAuth: true
        },
        granted: ac => ac.check("/statistics/summary")
      },
      {
        path: "article",
        component: Article,
        name: "文章统计",
        meta: {
          title: "文章统计",
          requiresAuth: true
        },
        granted: ac => ac.check("/statistics/article")
      },
      {
        path: "transactions",
        component: Transactions,
        name: "钱包流水",
        meta: {
          title: "钱包流水",
          requiresAuth: true
        },
        granted: ac => ac.check("/statistics/transactions")
      }
    ]
  },

  {
    path: "/tools",
    component: Tools,
    name: "工具",
    children: [
      { path: "/", redirect: "ProductUpdate" },
      {
        path: "ProductUpdate",
        name: "刷新产品列表",
        component: ProductUpdate,
        meta: { title: "刷新产品列表", requiresAuth: true },
        granted: ac => {
          return ac.check("/partner/product_process_info_get");
        }
      },
      {
        path: "WxMenuUpdate",
        name: "微信菜单刷新",
        component: WxMenuUpdate,
        meta: { title: "微信菜单刷新", requiresAuth: true },
        granted: ac => {
          return ac.check("/tools/wx_menu_update");
        }
      },
      {
        path: "domain_list",
        name: "cms域名管理",
        component: DomainList,
        granted: ac => ac.check("/tools/cms_domain_list")
      },
      {
        path: "material_media",
        name: "微信media_id",
        component: WxMediaId,
        granted: ac => ac.check("/tools/wx_media_id")
      },
      {
        path: "ChatRoomList",
        name: "微信群机器人设置",
        component: ChatRoomList,
        granted: ac => ac.check("/tools/chat_room_list")
      },
      {
        path: "QrCodeChannelList",
        name: "渠道邀请二维码",
        component: QrCodeChannelList,
        granted: ac => ac.check("/tools/qr_code_channel_list")
      },
      {
        path: "GenerateImg",
        name: "生成图片",
        component: GenerateImg,
        granted: ac => ac.check("/tools/GenerateImg")
      },
      {
        path: "ChangeDomain",
        name: "切换域名",
        component: ChangeDomain,
        granted: ac => ac.check("/tools/ChangeDomain")
      },
      {
        path: "MessageBroadcast",
        name: "消息模板",
        component: MessageBroadcast,
        granted: ac => ac.check("/shop/MessageBroadcast")
      },
      { 
        path: 'notice', 
        name: '通知', 
        component: Notice, 
        granted: ac => ac.check("/messenger/notice_list")
      },
      {
        path: "param",
        name: "剧场配置",
        component: Param,
        granted: ac => ac.check("/shop/order_list")
      },
      {
        path: "userTag",
        name: "用户标签管理",
        component: UserTagManage,
        granted: ac => ac.check("/shop/order_list")
      },
      {
        path: "userTag/:group/:group_name",
        component: UserTagItem,
        granted: ac => ac.check("/shop/order_list")
      }
    ]
  },
  {
    path: '/shop',
    component: Shop,
    name: '商城',
    children: [
      { path: "/", redirect: "ShopOrder" },
      {
        path: "UserLevelRights",
        name: "会员级别功能设定",
        component: UserLevelRights,
        granted: ac => ac.check("/tools/vip_level_rights")
      },
      {
        path: "MemberProduct",
        name: "会员产品",
        component: MemberProduct,
        granted: ac => ac.check("/shop/vip_member_product")
      },
      {
        path: "AssignMembers",
        name: "会员分配列表",
        component: AssignMembers,
        granted: ac => ac.check("/shop/vip_assign_members")
      },
      {
        path: "ShopOrder",
        name: "订单管理",
        component: ShopOrder,
        granted: ac => ac.check("/shop/order_list")
      },
      {
        path: "ShopChannel",
        name: "渠道管理",
        component: ShopChannelList,
        granted: ac => ac.check("/shop/channel_list")
      },
      {
        path: 'ShopChannelItemList/:channel',
        component: ShopChannelItemList,
        granted: ac => ac.check('/shop/item_list')
      },
      {
        path: 'ShopChannelSaleList/:channel',
        component: ShopChannelSaleList,
        granted: ac => ac.check('/shop/order_list')
      },
      {
        path: 'ShopChannelStatistics/:channel',
        component: ShopChannelStatistics,
        granted: ac => ac.check('/shop/channel_statistics_list') && ac.check("/shop/channel_statistics_sum_get")
      },
      {
        path: "ActivityList",
        name: "活动列表",
        component: ActivityList,
        granted: ac => ac.check("/activity/activity_create")
      }
    ]
  },
  
    {
        path: "/user",
        component: User,
        name: "用户管理",
        children: [
            { path: "/", redirect: "list" },
            {
                path: "list",
                name: "用户列表",
                component: UserList,
                meta: { title: "用户列表", requiresAuth: true },
                granted: ac => ac.check("/front/user_get_list")
            },
            {
                path: "detail/:uid",
                component: UserDetail,
                meta: {
                    title: "用户详情",
                    nonav1: true,
                    nonav2: true,
                    requiresAuth: true
                },
                granted: ac => ac.check("/front/user_get_detail")
            },
            {
                path: "account_list",
                name: "支付订单列表",
                component: UserAccountList,
                meta: { title: "用户支付订单列表" },
                granted: ac => ac.check("/front/user_get_account_list")
            }
        ]
    },
    {
        path: "/agent",
        granted: ac => ac.check("/agent/agent_get_list"),
        component: Agent,
        name: "代理人管理",
        children: [
            { path: "/", redirect: "list" },
            {
                path: "list",
                name: "代理人列表",
                component: AgentList,
                granted: ac => ac.check("/agent/agent_get_list")
            },
            {
                path: "detail/:aid",
                component: AgentDetail,
                meta: {
                    title: "代理人详情",
                    nonav1: true,
                    nonav2: true,
                    requiresAuth: true
                },
                granted: ac => ac.check("/agent/agent_get_detail")
            },
            {
                path: "custom/:client_id/:person_id",
                component: AgentCustom,
                meta: {title: "代理人详情",
                    nonav1: true,
                    nonav2: true,
                    requiresAuth: true
                },
                granted: ac => ac.check("/agent/agent_custom_get")
            },
            {
                path: "VerifyList",
                name: "代理人审核列表",
                component: AgentVerifyList,
                granted: ac => ac.check("/agent/verify_get_list")
            },
            {
                path: "VerifyLogList/:lid",
                component: VerifyLogList,
                meta: {
                    title: "代理人审核日志列表",
                    nonav1: true,
                    nonav2: true,
                    requiresAuth: true
                },
                granted: ac => ac.check("/agent/verify_get_log_list")
            },
            {
                path: "ClientList",
                name: "代理人客户列表",
                component: AgentClientList,
                granted: ac => ac.check("/agent/client_get_list")
            },
            {
                path: "VCardRiskWarn",
                name: "代理人名片审核",
                component: AgentVCardWarn,
                granted: ac => ac.check("/agent/vcard_warn")
            }
        ]
    },
  {
      path: '/erp',
      component: ERP,
      children: [
          { path: '/', redirect: "list" },
          { path: 'list', name: '待处理', component: ERPTodo, granted: ac => ac.check("/erp/list")},
          { path: 'edit/:id/:type/:uid/:classify', component: ERPEdit, granted: ac => ac.check("/erp/edit") }
      ]
  },
  {
      name: '客服',
      path: '/custom-service',
      component: CustomService,
      children: [
          { path: '/', redirect: "customer" },
          { path: 'team', name: '团队列表', component: TeamList, granted: ac => ac.check("/cs/team_list")},
          { path: 'member', name: '团队成员列表', component: TeamMember, granted: ac => ac.check("/cs/notice_list")},
          { path: 'customer', name: '客户列表', component: CustomerList, granted: ac => ac.check("/cs/customer_list")},
          { path: 'pending/:user_id', component: PendingEvent},
      ]
  }, 
  /*{
      name: '供应链管理',
      path: '/supply_chain',
      component: SupplyChainManage,
      children: [
          { path: '/', redirect: "supply_chain/100" },
          { path: 'supply_chain/100', name: '已上架', component: SupplyChainManage, granted: ac => ac.check("/product/manage_list")},
          { path: 'supply_chain/910', name: '已下架', component: SupplyChainManage, granted: ac => ac.check("/product/manage_list")},
          { path: 'supply_chain/0', name: '待分配', component: SupplyChainManage, granted: ac => ac.check("/product/manage_list")},
          { path: 'supply_chain/920', name: '已停售', component: SupplyChainManage, granted: ac => ac.check("/product/manage_list")},
      ]
  },*/
    {
        name: 'Saas',
        path: '/saas',
        component: Saas,
        children: [
            { path: '/', redirect: "saas_user" },
            { path: 'saas_user', name: 'saas用户列表', component: SaasUser, granted: ac => ac.check("/product/manage_list")},
            { path: 'saas_supply_chain', name: 'saas供应链产品', component: SaasSupplyChainManage, granted: ac => ac.check("/product/manage_list")},
            { path: 'saas_product', name: 'saas主产品列表', component: SaasProductList, granted: ac => ac.check("/product/manage_list")},
            { path: 'saas_certification', name: '实名认证申请', component: SaasCertification, granted: ac => ac.check("/product/manage_list")},
            { path: 'saas_order', name: '订单管理', component: SaasOrder, granted: ac => ac.check("/product/manage_list")},
            //{ path: 'saas_reward', name: '奖励列表', component: SaasRewardList, granted: ac => ac.check("/product/manage_list")},
            { path: 'saas_setting', name: '奖励设置', component: SaasRewardSetting, granted: ac => ac.check("/product/manage_list")},
            { path: 'saas_settlement_rate', name: '佣金率模板设置', component: SettlementRate, granted: ac => ac.check("/product/manage_list")},
            { path: 'saas_tax_rate', name: '税率模板设置', component: TaxRate, granted: ac => ac.check("/product/manage_list")},
            { path: 'saas_withdraw_record', name: '提现申请', component: SaasWithdrawRecord, granted: ac => ac.check("/product/manage_list")},
            { path: 'saas_activity_withdraw_apply', name: '活动提现申请', component: SaasActivityWithdrawApply, granted: ac => ac.check("/product/manage_list")},
            { path: 'saas_channel', name: '邀请渠道', component: SaasChannel, granted: ac => ac.check("/product/manage_list")},
            { path: 'saas_tools', name: '工具', component: SaasTools, meta: { title: "工具", requiresAuth: true }, granted: ac => ac.check("/product/manage_list")},
            { 
                path: 'saas_user_edit/:id', 
                component: SaasUserDetailAndRemark,
                meta: { title: "用户详情", requiresAuth: true, nonav2: true },
                granted: ac => ac.check("/product/manage_list")
            }
        ]
    },
  {
    path: "/admin",
    component: Admin,
    name: "管理员",
    right: true,
    children: [
      { path: "/", redirect: "list" },
      {
        path: "list",
        name: "管理员列表",
        component: AdminList,
        meta: { title: "管理员列表", requiresAuth: true },
        granted: ac => {
          return ac.check("/admin/get_list");
        }
      }
    ]
  }
];

export default new VueRouter({
  routes
});
